import React from 'react';
import { useSelector } from 'react-redux';
import RichHTML from '../components/RichHTML'; 
import CategoryPage from "./CategoryPage";
import EventsPage from '../components/EventPage';
import CityContactsPage from '../components/Contacts';

export default function LocalContent() {
  const { activeTab, about='', history='', contacts={}, businesses=[], events=[] } =
    useSelector(s => s.local || {});

  const { city, county, state, label } = useSelector(s => s.local?.location) || {};
  const display = city || county || state || label || 'California';

  console.log(state, display);
  return (
    <>
      {activeTab === 'about' && (
        <Section title="">
          <article className="prose lg:prose-lg max-w-4xl mx-auto">
            <RichHTML html={about} />
          </article>
        </Section>
      )}

      {activeTab === 'news' && (
        <Section title="">
            <CategoryPage />
        </Section>
      )}

 
      {activeTab === 'history' && (
        
          <article className="prose lg:prose-lg max-w-4xl mx-auto">
            <RichHTML html={history} />
          </article>
  
      )}

      {activeTab === 'contacts' && (
        <Section title="">
          
            <CityContactsPage  state={state} city={display} />
           </Section>
      )}

      {activeTab === 'businesses' && (
        <Section title="Businesses">
          <ul className="list">
            {businesses.map(b => (
              <li key={b.id}>
                <strong>{b.name}</strong><br />
                <small>{b.address}</small> · <small>{b.phone}</small>
              </li>
            ))}
          </ul>
        </Section>
      )}

      {activeTab === 'events' && (
        <Section title="">
          <EventsPage />
        </Section>
      )}
    </>
  );
}

function Section({ title, children }) {
  return <div className="section">{title && <h2>{title}</h2>}{children}</div>;
}